import { useNavigate } from "react-router-dom";
import { H1, LinkButton, Table } from "@components";
import { GridColDef } from "@mui/x-data-grid";
import { StarIcon } from "@heroicons/react/24/outline";
import { formatDate } from "@libs/utils";
import { TemplatesActionsCell } from "features/languages/components/TemplatesActionsCell";
import { useFetchValidationTemplates } from "features/languages/hooks/useFetchValidationTemplates";
import { ValidationTemplateSummary } from "features/languages/types/validation-templates";

const columns: GridColDef<ValidationTemplateSummary>[] = [
  {
    field: "isDefault",
    headerName: "",
    renderCell: ({ row }) => (row.isDefault ? <StarIcon width={16} height={16} /> : null),
    width: 16,
    sortable: false,
  },
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    sortable: true,
  },
  {
    field: "author",
    headerName: "Author",
    flex: 1,
    align: "left",
    sortable: true,
  },
  {
    field: "dateModified",
    headerName: "Date",
    width: 140,
    renderCell: ({ row }) => formatDate(row.dateModified),
    align: "left",
    sortable: false,
  },
  {
    field: "actions",
    headerName: "Actions",
    renderCell: TemplatesActionsCell,
    align: "center",
    sortable: false,
  },
];

export const ValidationTemplatesTabPage = () => {
  const [validationRules, isLoading] = useFetchValidationTemplates();
  const navigate = useNavigate();

  const onRowClick = (params: any) => {
    const to = `/validation-rules/edit/${params?.row.id}`;

    navigate(to);
  };

  return (
    <>
      <H1 label="Templates">
        <LinkButton to="/validation-rules/create" label="Add Template" />
      </H1>
      {isLoading ? null : (
        <Table
          rows={validationRules}
          columns={columns}
          initialState={{
            sorting: {
              sortModel: [{ field: "name", sort: "asc" }],
            },
          }}
          onRowClick={onRowClick}
          storageId="validationTemplates"
        />
      )}
    </>
  );
};
